import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { FormsModule, ReactiveFormsModule, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CommonModule } from '@angular/common';
import { ActionName, KENDO_LISTBOX, ListBoxModule, ListBoxSelectionEvent } from "@progress/kendo-angular-listbox";

import { ContactsGridNotificationTemplateAssociations } from '../../models/notifications/contacts-grid-notification-template-association.model';
import { FormFieldNotificationTemplateAssociation } from '../../models/notifications/form-field-notification-template-association.model';

// Define a class for creating and invoking an instance of EditEmailTemplatesDialog.
export class EmailTemplateSelectionDialogManager {
    // Property.
    //public selectedFormFieldNotificationTemplateAssociation: FormFieldNotificationTemplateAssociation = null;
    public notificationTemplateId: number = null;

    // Constructor.
    public constructor(public templateData: ContactsGridNotificationTemplateAssociations) {
    }

    public openDialogUsing(dialog: MatDialog): MatDialogRef<EmailTemplateSelectionDialog, EmailTemplateSelectionDialogManager> {
        const dialogRef = dialog.open(EmailTemplateSelectionDialog,
            {
                data: this,
                hasBackdrop: false, // See https://stackblitz.com/edit/angular-173jnz?file=src%2Fapp%2Fdialog-content-example.ts for an example of how to use this.
                width: '600px',
                height: '350px',
                panelClass: 'custom-mat-dialog-panel'
            });
        return dialogRef;
    }
}

@Component({
    selector: 'app-email-template-selection',
    imports: [KENDO_LISTBOX, FormsModule, ReactiveFormsModule, MatDialogModule, MatButtonModule, CommonModule, MatFormFieldModule, MatInputModule, ReactiveFormsModule],
    templateUrl: './email-template-selection.dialog.html',
    styleUrl: './email-template-selection.dialog.scss',
    standalone: true,
    //encapsulation: ViewEncapsulation.None //enable CSS overrides
    encapsulation: ViewEncapsulation.Emulated
})
export class EmailTemplateSelectionDialog {
    // Properties.
    private selectedFormFieldNotificationTemplateAssociation: FormFieldNotificationTemplateAssociation = null;

    // Constructor.
    public constructor(public dialogRef: MatDialogRef<EmailTemplateSelectionDialog>,
        @Inject(MAT_DIALOG_DATA) public initData: EmailTemplateSelectionDialogManager) {
    }

    // Life cycle methods.
    public ngOnInit(): void {
    }

    // Methods called by my HTML code.
    public get AvailableEmailTemplates(): FormFieldNotificationTemplateAssociation[] {
        return this.initData.templateData.formFieldNotificationTemplateAssociations;
    }

    // Handle control events.
    public emailTemplateSelectionChange(eventData: any): void {
        // Set the selected template based on the provided information.
        this.selectedFormFieldNotificationTemplateAssociation = null;

        if ((eventData.selectedIndices != null) && (eventData.selectedIndices.length == 1)) {
            const selectedIndex = eventData.selectedIndices[0];

            if ((selectedIndex >= 0) && (selectedIndex < this.initData.templateData.formFieldNotificationTemplateAssociations.length))
                this.selectedFormFieldNotificationTemplateAssociation = this.initData.templateData.formFieldNotificationTemplateAssociations[selectedIndex];
        }
    }

    public emailTemplateAction(eventData: any): void {
    }

    public selectEmailTemplate(): void {
        this.initData.notificationTemplateId = this.selectedFormFieldNotificationTemplateAssociation.notificationTemplateId;

        this.dialogRef.close(this.initData);
    }

    public cancelDialogue(): void {
        this.dialogRef.close(null);
    }
}
